import script from "./hotelOrders.vue?vue&type=script&setup=true&lang=js"
export * from "./hotelOrders.vue?vue&type=script&setup=true&lang=js"

import "./hotelOrders.vue?vue&type=style&index=0&id=6ce06788&lang=scss"

const __exports__ = script;

export default __exports__